import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/settings/lang"

export const Route = createFileRoute("/_base/_auth/settings")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.header.title"),
    })
  },
})
